import TikTok from './TikTok'

export default TikTok
// eslint-disable-next-line import/export
export * from './TikTok'
